
import store from "../store";
import { logDetailed } from "./utils";

let patientRefreshIntervalID = 0;
let patientRefreshTimeout = 30000; // 30 seconds
export function setupRefreshPatientLoop() {
    logDetailed("patientRefresh", "setupRefreshPatientLoop");
    if (patientRefreshIntervalID) window.clearInterval(patientRefreshIntervalID);
    if (!store.getters.ssoEmrPro) {
        patientRefreshIntervalID = window.setInterval(refreshPatientList, patientRefreshTimeout);
    }
}
export function disableRefreshPatientLoop() {
    logDetailed("patientRefresh", "disableRefreshPatientLoop");
    if (patientRefreshIntervalID) window.clearInterval(patientRefreshIntervalID);
}

function refreshPatientList() {
    logDetailed("patientRefresh", "refreshPatientList");
    if (!store.getters.isAuthenticated) return;
    if (store.getters.loadingPatients) return;
    if (store.getters.loadingExams) return;
    if (!store.getters.autoRefreshPatientList) return;
    return store.dispatch("getPatients", true);
}